import EventBus from "../components/event-bus";
import Cleave from 'cleave.js';
import moment from 'moment';
import CrediOverrideNotification from "@/components/customer/CreditOverrideNotification.vue";
import Translator from './translatorMixins';

export const commonMixins = {

  data() {
    return {
      reqInProcess: 0,
      errorMsg: "",
      // googleUrl:"https://docs.google.com/viewerng/viewer?url=",
      googleUrl: "https://view.officeapps.live.com/op/embed.aspx?src=",
      cpiAnniversaryPointArr: [
        {text: "Last Increase Date", value: "L"},
        {text: "Unit Assignment Date", value: "U"}
      ],
      odometerDeviceArr: [
        {text: "PLATFORM SCIENCE", value: "platform_science"},
        {text: "TELOGIS", value: "telogis"},
        {text: "ZONAR", value: "zonar"}
      ],
      rateTypeArr: [
        {value: "day", text: "Day"},
        {value: "week", text: "Week"},
        {value: "month", text: "Month"},
        {value: "mile", text: "Mile"},
        {value: "hour", text: "Hour"}
      ],
      timeArr: [{value: "07:00:00", text: "07:00 AM"},
        {value: "07:15:00", text: "07:15 AM"},
        {value: "07:30:00", text: "07:30 AM"},
        {value: "07:45:00", text: "07:45 AM"},
        {value: "08:00:00", text: "08:00 AM"},
        {value: "08:15:00", text: "08:15 AM"},
        {value: "08:30:00", text: "08:30 AM"},
        {value: "08:45:00", text: "08:45 AM"},
        {value: "09:00:00", text: "09:00 AM"},
        {value: "09:15:00", text: "09:15 AM"},
        {value: "09:30:00", text: "09:30 AM"},
        {value: "09:45:00", text: "09:45 AM"},
        {value: "10:00:00", text: "10:00 AM"},
        {value: "10:15:00", text: "10:15 AM"},
        {value: "10:30:00", text: "10:30 AM"},
        {value: "10:45:00", text: "10:45 AM"},
        {value: "11:00:00", text: "11:00 AM"},
        {value: "11:15:00", text: "11:15 AM"},
        {value: "11:30:00", text: "11:30 AM"},
        {value: "11:45:00", text: "11:45 AM"},
        {value: "12:00:00", text: "12:00 PM"},
        {value: "12:15:00", text: "12:15 PM"},
        {value: "12:30:00", text: "12:30 PM"},
        {value: "12:45:00", text: "12:45 PM"},
        {value: "13:00:00", text: "01:00 PM"},
        {value: "13:15:00", text: "01:15 PM"},
        {value: "13:30:00", text: "01:30 PM"},
        {value: "13:45:00", text: "01:45 PM"},
        {value: "14:00:00", text: "02:00 PM"},
        {value: "14:15:00", text: "02:15 PM"},
        {value: "14:30:00", text: "02:30 PM"},
        {value: "14:45:00", text: "02:45 PM"},
        {value: "15:00:00", text: "03:00 PM"},
        {value: "15:15:00", text: "03:15 PM"},
        {value: "15:30:00", text: "03:30 PM"},
        {value: "15:45:00", text: "03:45 PM"},
        {value: "16:00:00", text: "04:00 PM"},
        {value: "16:15:00", text: "04:15 PM"},
        {value: "16:30:00", text: "04:30 PM"},
        {value: "16:45:00", text: "04:45 PM"},
        {value: "17:00:00", text: "05:00 PM"},
        {value: "17:15:00", text: "05:15 PM"},
        {value: "17:30:00", text: "05:30 PM"},
        {value: "17:45:00", text: "05:45 PM"},
        {value: "18:00:00", text: "06:00 PM"},
        {value: "18:15:00", text: "06:15 PM"},
        {value: "18:30:00", text: "06:30 PM"},
        {value: "18:45:00", text: "06:45 PM"},
        {value: "19:00:00", text: "07:00 PM"},
        {value: "19:15:00", text: "07:15 PM"},
        {value: "19:30:00", text: "07:30 PM"},
        {value: "19:45:00", text: "07:45 PM"},
        {value: "20:00:00", text: "08:00 PM"},
        {value: "20:15:00", text: "08:15 PM"},
        {value: "20:30:00", text: "08:30 PM"},
        {value: "20:45:00", text: "08:45 PM"},
        {value: "21:00:00", text: "09:00 PM"},
        {value: "21:15:00", text: "09:15 PM"},
        {value: "21:30:00", text: "09:30 PM"},
        {value: "21:45:00", text: "09:45 PM"},
        {value: "22:00:00", text: "10:00 PM"},
        {value: "22:15:00", text: "10:15 PM"},
        {value: "22:30:00", text: "10:30 PM"},
        {value: "22:45:00", text: "10:45 PM"},
        {value: "23:00:00", text: "11:00 PM"},
        {value: "23:15:00", text: "11:15 PM"},
        {value: "23:30:00", text: "11:30 PM"},
        {value: "23:45:00", text: "11:45 PM"},
        {value: "00:00:00", text: "12:00 AM"},
        {value: "00:15:00", text: "12:15 AM"},
        {value: "00:30:00", text: "12:30 AM"},
        {value: "00:45:00", text: "12:45 AM"},
        {value: "01:00:00", text: "01:00 AM"},
        {value: "01:15:00", text: "01:15 AM"},
        {value: "01:30:00", text: "01:30 AM"},
        {value: "01:45:00", text: "01:45 AM"},
        {value: "02:00:00", text: "02:00 AM"},
        {value: "02:15:00", text: "02:15 AM"},
        {value: "02:30:00", text: "02:30 AM"},
        {value: "02:45:00", text: "02:45 AM"},
        {value: "03:00:00", text: "03:00 AM"},
        {value: "03:15:00", text: "03:15 AM"},
        {value: "03:30:00", text: "03:30 AM"},
        {value: "03:45:00", text: "03:45 AM"},
        {value: "04:00:00", text: "04:00 AM"},
        {value: "04:15:00", text: "04:15 AM"},
        {value: "04:30:00", text: "04:30 AM"},
        {value: "04:45:00", text: "04:45 AM"},
        {value: "05:00:00", text: "05:00 AM"},
        {value: "05:15:00", text: "05:15 AM"},
        {value: "05:30:00", text: "05:30 AM"},
        {value: "05:45:00", text: "05:45 AM"},
        {value: "06:00:00", text: "06:00 AM"},
        {value: "06:15:00", text: "06:15 AM"},
        {value: "06:30:00", text: "06:30 AM"},
        {value: "06:45:00", text: "06:45 AM"},


      ],
      rentalTypeArr: [{
        value: "rental",
        text: "Rental"
      },
        {
          value: "transfer",
          text: "Transfer"
        },
      ],
      dateFormatArr: [
        // {
        //     value: "m-d-Y",
        //     text: "12-23-2019"
        // },
        // {
        //     value: "d-m-Y",
        //     text: "23-12-2019"
        // },
        {
          value: "m/d/Y",
          text: "12/23/2019"
        },
        // {
        //     value: "d/m/Y",
        //     text: "23/12/2019"
        // }
      ],
      timeFormatArr: [{
        value: "h:i:s a",
        text: "09:58:00 am"
      },
        // {
        //     value: "h:i a",
        //     text: "09:58 am"
        // },
        // {
        //     value: "H:i",
        //     text: "21:58"
        // },
        // {
        //     value: "H:i:s",
        //     text: "21:58:00"
        // },
      ],
      flashit_flag: false,
      startingPointArr: [
        // {value:'E',text:'E (Effective)'},
        {value: 'I', text: 'I (In Service Date)'},
        {value: 'P', text: 'P (Purchase)'}],
      companyArr: [{text: 'Velocity Vehicle Group', value: 'VVG'},
        {text: 'Velocity Truck Center', value: 'VTC'},
        {text: 'Velocity Truck Rental and Leasing', value: 'VTRL'}],
      contractTypesArr: [{text: 'Rental', value: 'rental'},
        {text: 'Lease', value: 'lease'},
        {text: 'Maintenance', value: 'maintenance'}],
      purchaseOrderTypesArr: [{text: 'Item', value: 'item'},
        {text: 'Equipment', value: 'equipment'},
        {text: 'Contract', value: 'contract'}],
      fromWhereArr: [{text: 'Customer', value: 'customer'},
        {text: 'Self', value: 'self'}],
      engineArr: [{text: 'Caterpillar', value: 'Caterpillar'}, {text: 'Chevy', value: 'Chevy'}, {
        text: 'Chrysler',
        value: 'Chrysler'
      }, {text: 'Cummins', value: 'Cummins'}
        , {text: 'DAF', value: 'DAF'}, {text: 'DMC', value: 'DMC'}, {text: 'Detroit', value: 'Detroit'}, {
          text: 'Dodge',
          value: 'Dodge'
        }, {text: 'Duramax', value: 'Duramax'}, {text: 'Ford', value: 'Ford'}
        , {text: 'GMC', value: 'GMC'}, {text: 'Hino', value: 'Hino'}, {
          text: 'International',
          value: 'International'
        }, {text: 'Isuzu', value: 'Isuzu'}, {text: 'Iveco', value: 'Iveco'}, {text: 'Mack', value: 'Mack'},
        {text: 'MAN', value: 'MAN'}, {text: 'Mercedes', value: 'Mercedes'}, {
          text: 'Mitsubishi',
          value: 'Mitsubishi'
        }, {text: 'Nissan', value: 'Nissan'}, {text: 'Paccar', value: 'Paccar'}, {
          text: 'Powerstroke',
          value: 'Powerstroke'
        }, {text: 'Renault', value: 'Renault'}
        , {text: 'Scania', value: 'Scania'}, {text: 'Tata', value: 'Tata'}, {
          text: 'Toyota',
          value: 'Toyota'
        }, {text: 'UD', value: 'UD'}, {text: 'Volvo', value: 'Volvo'}, {text: 'Westport', value: 'Westport'}],
      transArr: [{text: 'Automated', value: 'Automated'},
        {text: 'Automatic', value: 'automatic'},
        {text: 'Manual', value: 'manual'}],
      transModelArr: [{text: 'Allison', value: 'Allison'}, {
        text: 'Allison TC 10',
        value: 'Allison TC 10'
      }, {text: 'Autoshift', value: 'Autoshift'}, {text: 'Detroit DT12', value: 'DT12'},
        {text: 'Endurant', value: 'Endurant'}, {text: 'Freedom Line', value: 'Freedom Line'}, {
          text: 'I Shift',
          value: 'I Shift'
        }, {text: 'mDRIVE', value: 'mDRIVE'}, {text: 'mDRIVE HD', value: 'mDRIVE HD'}
        , {text: 'Paccar AMT', value: 'Paccar AMT'}, {
          text: 'Smart Advantage',
          value: 'Smart Advantage'
        }, {text: 'Ultrashift', value: 'Ultrashift'}, {text: 'Ultrashift Plus', value: 'Ultrashift Plus'}],
      numspeedArr: [{text: '4 Spd', value: '4 Spd'}, {text: '4+2 Spd', value: '4+2 Spd'}, {
        text: '4+4 Spd',
        value: '4+4 Spd'
      }, {text: '5 Spd', value: '5 Spd'}, {text: '5+2 Spd', value: '5+2 Spd'},
        {text: '6 Spd', value: '6 Spd'}, {text: '5+4 Spd', value: '5+4 Spd'}, {
          text: '6+1 Spd',
          value: '6+1 Spd'
        }, {text: '6+2 Spd', value: '6+2 Spd'}, {text: '6+4 Spd', value: '6+4 Spd'}, {text: '7 Spd', value: '7 Spd'}, {
          text: '7LL', value: '7LL'
        }, {text: '8 Spd', value: '8 Spd'}, {text: '8LL', value: '8LL'}, {text: '9 Spd', value: '9 Spd'}, {
          text: '9LL',
          value: '9LL'
        }, {text: '10 Spd', value: '10 Spd'}, {text: '10+4 Spd', value: '10+4 Spd'},
        {text: 'Super 10 Spd', value: 'Super 10 Spd'}, {text: '11 Spd', value: '11 Spd'}, {
          text: '12 Spd',
          value: '12 Spd'
        }, {text: '13 Spd', value: '13 Spd'}, {text: '14 Spd', value: '14 Spd'}, {text: '15 Spd', value: '15 Spd'},
        {text: '16 Spd', value: '16 Spd'}, {text: '18 Spd', value: '18 Spd'}],
      transManufacturerArr: [{text: 'AISIN', value: 'AISIN'}, {text: 'ALLISON', value: 'ALLISON'}, {
        text: 'BORG-WARNER',
        value: 'BORG-WARNER'
      }, {text: 'CATERPILLAR', value: 'CATERPILLAR'},
        {text: 'CLARK', value: 'CLARK'}, {text: 'DETROIT', value: 'DETROIT'}, {
          text: 'EATON',
          value: 'EATON'
        }, {text: 'EATON-FULLER', value: 'EATON-FULLER'}, {text: 'FORD', value: 'FORD'},
        {text: 'FULLER', value: 'FULLER'}, {text: 'GM', value: 'GM'}, {
          text: 'INTERNATIONAL',
          value: 'INTERNATIONAL'
        }, {text: 'IVECO', value: 'IVECO'}, {text: 'ISUZU', value: 'ISUZU'},
        {text: 'KIT MASTERS', value: 'KIT MASTERS'}, {text: 'MACK', value: 'MACK'}, {
          text: 'MAN',
          value: 'MAN'
        }, {text: 'MERCEDES', value: 'MERCEDES'}, {text: 'MERCEDES-BENZ', value: 'MERCEDES-BENZ'},
        {text: 'MERITOR', value: 'MERITOR'}, {text: 'MITSUBISHI FUSO', value: 'MITSUBISHI FUSO'}, {
          text: 'NEW PROCESS',
          value: 'NEW PROCESS'
        }, {text: 'PACCAR', value: 'PACCAR'}, {text: 'RENAULT', value: 'RENAULT'},
        {text: 'ROCKWELL', value: 'ROCKWELL'}, {text: 'SCANIA', value: 'SCANIA'}, {
          text: 'SPICER',
          value: 'SPICER'
        }, {text: 'VOITH', value: 'VOITH'}, {text: 'VOLVO', value: 'VOLVO'}, {text: 'ZF', value: 'ZF'}],
      sleeperTypeArr: [{text: 'Flat Top Sleeper', value: 'Flat Top Sleeper'}, {
        text: 'Mid Roof Sleeper',
        value: 'Mid Roof Sleeper'
      }, {text: 'Raised Roof Sleeper', value: 'Raised Roof Sleeper'}],
      wheelBaseArr: [{text: 'Aluminum', value: 'Aluminum'}, {
        text: 'All Aluminum',
        value: 'All Aluminum'
      }, {text: 'Aluminum/Steel', value: 'Aluminum/Steel'},
        {text: 'Aluminum/Spoke', value: 'Aluminum/Spoke'}, {
          text: 'Aluminum Outside',
          value: 'Aluminum Outside'
        }, {text: 'All Steel', value: 'All Steel'}, {text: 'Polished Aluminum', value: 'Polished Aluminum'},
        {text: 'Spoke', value: 'Spoke'}, {text: 'Budd', value: 'Budd'}, {text: 'Steel Disc', value: 'Steel Disc'}],
      suspArr: [{text: 'Air Ride', value: 'Air Ride'}, {text: 'Spring', value: 'Spring'}, {
        text: '4 Spring',
        value: '4 Spring'
      }, {text: '4 Bag Air Ride', value: '4 Bag Air Ride'}, {
        text: '8 Bag Air Ride',
        value: '8 Bag Air Ride'
      }, {text: 'AG 100', value: 'AG 100'}, {text: 'AG 130', value: 'AG 130'},
        {text: 'AG 200', value: 'AG 200'}, {text: 'AG 210L', value: 'AG 210L'}, {
          text: 'AG 380',
          value: 'AG 380'
        }, {text: 'AG 400', value: 'AG 400'}, {text: 'AG 400L', value: 'AG 400L'}, {
          text: 'AG 460',
          value: 'AG 460'
        }, {text: 'AirLiner', value: 'AirLiner'}, {text: 'Air Glide', value: 'Air Glide'},
        {text: 'Air Leaf', value: 'Air Leaf'}, {text: 'Air Trac', value: 'Air Trac'}, {
          text: 'Camelback',
          value: 'Camelback'
        }, {text: 'Center Point', value: 'Center Point'}, {text: 'Chalmers', value: 'Chalmers'}, {
          text: 'Flex Air',
          value: 'Flex Air'
        }, {text: 'HaulMaax', value: 'HaulMaax'},
        {text: 'Hendrickson', value: 'Hendrickson'}, {
          text: 'Hendrickson HMX460',
          value: 'Hendrickson HMX460'
        }, {text: 'Hendrickson HN', value: 'Hendrickson HN'}, {
          text: 'Hendrickson PRIMAAX',
          value: 'Hendrickson PRIMAAX'
        }, {text: 'Intraax', value: 'Intraax'}, {text: 'Low Air', value: 'Low Air'},
        {text: 'Leaf Springs', value: 'Leaf Springs'}, {text: 'Mack', value: 'Mack'}, {
          text: 'Mack mRIDE',
          value: 'Mack mRIDE'
        }, {text: 'Mack Twin Y', value: 'Mack Twin Y'}, {text: 'Multi Leaf', value: 'Multi Leaf'}, {
          text: 'Newair',
          value: 'Newair'
        }, {text: 'Neway', value: 'Neway'},
        {text: 'Pete Low Air Leaf', value: 'Pete Low Air Leaf'}, {text: 'Paccar', value: 'Paccar'}, {
          text: 'Reyco',
          value: 'Reyco'
        }, {text: 'Ridewell', value: 'Ridewell'}, {text: 'Rubber Block', value: 'Rubber Block'}, {
          text: 'Single Point',
          value: 'Single Point'
        }, {text: 'T-Ride', value: 'T-Ride'},
        {text: 'Taper Leaf', value: 'Taper Leaf'}, {text: 'TufTrac', value: 'TufTrac'}, {
          text: 'Volvo Air Ride',
          value: 'Volvo Air Ride'
        }, {text: 'Volvo T-Ride', value: 'Volvo T-Ride'}, {text: 'Walking Beam', value: 'Walking Beam'}],
      modulesArr: [{text: 'Invoice', value: 'invoice'}
        , {text: 'Vendor Invoice', value: 'vendor invoice'}
        , {text: 'Amortized Permit', value: 'permit customer mapper'}
        , {text: 'Amortized FHUT', value: 'processed hvut schedule'}
        , {text: 'Asset', value: 'asset'}],
      checkStatusArr: [{text: 'Active', value: 'active'}, {text: 'Void', value: 'void'}, {
        text: 'In Progress',
        value: 'in progress'
      }, {text: 'Processed', value: 'processed'}],
      billingFrequencyArr: [{text: 'Monthly', value: 'monthly'}, {text: 'Weekly', value: 'weekly'}],
      costMethodArr: [
        {text: 'Entered', value: 'entered'},
        {text: 'Average Cost', value: 'average cost'}
      ],
      reportNameArr: [{text: 'Fuel Ticket Detail', value: 'fuel ticket detail'}, {
        text: 'Unit Test',
        value: 'unit test'
      }, {text: 'Automation Test', value: 'automation test'}, {
        text: 'Delete Cpi Pdf and Html File',
        value: 'delete cpi pdf and html file'
      }, {text: 'Delete Export', value: 'delete export'},
        {text: 'Clear Debugbar', value: 'clear debugbar'}, {
          text: 'Customer Listing',
          value: 'customer listing'
        }, {text: 'Equipment Master', value: 'equipment master'}, {
          text: 'Unit Permit Detail',
          value: 'unit permit detail'
        }, {text: 'HVUT Unit Detail', value: 'hvut unit detail'}, {
          text: 'Insurance Policies',
          value: 'insurance policies'
        },
        {text: 'Customer Rental Scope Rates', value: 'customer rental scope rates'}, {
          text: 'General Ledger Detail',
          value: 'general ledger detail'
        }, {text: 'Invoice Detail', value: 'invoice detail'}, {
          text: 'Available Equipment',
          value: 'available equipment'
        }, {text: 'Lease Contracts', value: 'lease contracts'},
        {
          text: 'Rental Utilization Equipment Type Detail',
          value: 'rental utilization equipment type detail'
        }, {
          text: 'Owned Equipment Current Values',
          value: 'owned equipment current values'
        }, {text: 'Aged Trial Balance - Summary', value: 'aged trial balance - summary'},
        {
          text: 'Aged Trial Balance Detail As At',
          value: 'aged trial balance detail as at'
        }, {
          text: 'Aged Trial Balance Detail Grid',
          value: 'aged trial balance detail grid'
        }, {text: 'Annual Actual Metrics Vs Contract Metrics', value: 'annual actual metrics vs contract metrics'},
        {
          text: 'AP Payment Upload / Outstanding AP',
          value: 'ap payment upload / outstanding ap'
        }, {
          text: 'Ap Trial Balance As At Detail',
          value: 'ap trial balance as at detail'
        }, {
          text: 'Ap Voucher Distribution Edit',
          value: 'ap voucher distribution edit'
        }, {text: 'Ar Receipts And Applications', value: 'ar receipts and applications'},
        {text: 'Contract Revenue Detail', value: 'contract revenue detail'}, {
          text: 'Debt Note Balance Details',
          value: 'debt note balance details'
        }, {text: 'Debt Note Unit Detail', value: 'debt note unit detail'}, {
          text: 'Depreciation NBV As At',
          value: 'depreciation nbv as at'
        }, {text: 'Depreciation Review', value: 'depreciation review'},
        {text: 'Disposal Invoice Listing', value: 'disposal invoice listing'}, {
          text: 'Equipment Current Status',
          value: 'equipment current status'
        }, {text: 'Equipment Features', value: 'equipment features'}, {
          text: 'Equipment Pool Transfer',
          value: 'equipment pool transfer'
        }, {text: 'Gangsheet Details', value: 'gangsheet details'},
        {
          text: 'Inventory As At Detail',
          value: 'inventory as at detail'
        }, {
          text: 'Labor Management Detail (Rpt.Params)',
          value: 'labor management detail (rpt.params)'
        }, {
          text: 'Lease Contract Expiry Report',
          value: 'lease contract expiry report'
        }, {
          text: 'Lease Rental Current Insurance Policy Review',
          value: 'lease rental current insurance policy review'
        },
        {
          text: 'LTD Unit Profit And Loss Summary',
          value: 'ltd unit profit and loss summary'
        }, {text: 'Metrics Billed (Detail)', value: 'metrics billed (detail)'}, {
          text: 'Note Pad Review',
          value: 'note pad review'
        }, {text: 'Open On Account Cash', value: 'open on account cash'}, {
          text: 'Out Of Service History',
          value: 'out of service history'
        },
        {
          text: 'PM Compliance - Facility Level',
          value: 'pm compliance - facility level'
        }, {
          text: 'PM Compliance - Pool Level',
          value: 'pm compliance - pool level'
        }, {text: 'PM Unit Detail With History', value: 'pm unit detail with history'}, {
          text: 'PM Unit Forecast',
          value: 'pm unit forecast'
        }, {text: 'Rental Activity', value: 'rental activity'},
        {
          text: 'Rental Activity With Rates (Sys Parameters)',
          value: 'rental activity with rates (sys parameters)'
        }, {text: 'Rental Listing', value: 'rental listing'}, {
          text: 'Repair History',
          value: 'repair history'
        }, {text: 'Reservation Listing', value: 'reservation listing'}, {
          text: 'Sub Days In Period',
          value: 'sub days in period'
        }, {text: 'Velocity Non Billable Units', value: 'velocity non billable units'},
        {text: 'Warranty Claim Listing', value: 'warranty claim listing'}, {
          text: 'Weekly Rental Report',
          value: 'weekly rental report'
        }, {text: 'Equipment Feature Report (Sys param)', value: 'equipment feature report sys param'}],
      frequencyArr: [{text: 'Daily', value: 'daily'}, {text: 'Weekly', value: 'weekly'}, {
        text: 'Monthly',
        value: 'monthly'
      }],
      attachmentArr: [{text: 'Pdf', value: 'pdf'}, {text: 'Excel', value: 'excel'}, {text: 'Csv', value: 'csv'}],
      taxSummaryYearArr: [{text: "2022", value: "2022"}, {text: "2021", value: "2021"}, {
        text: "2020",
        value: "2020"
      }, {text: "2019", value: "2019"}, {text: "2018", value: "2018"}, {text: "2017", value: "2017"}, {
        text: "2016",
        value: "2016"
      }],
      statusArr: [{text: 'Active', value: 'Active'}, {text: 'Billed', value: 'Billed'}, {
        text: 'Closed',
        value: 'Closed'
      }, {text: 'Pending', value: 'Pending'}, {text: 'Voided', value: 'Voided'}, {
        text: 'Standby',
        value: 'Standby'
      }, {text: 'Rented', value: 'Rented'}],
      hoursArr: [{value: "00:00", text: "00:00"},
        {value: "00:30", text: "00:30"},
        {value: "01:00", text: "01:00"},
        {value: "01:30", text: "01:30"},
        {value: "02:00", text: "02:00"},
        {value: "02:30", text: "02:30"},
        {value: "03:00", text: "03:00"},
        {value: "03:30", text: "03:30"},
        {value: "04:00", text: "04:00"},
        {value: "04:30", text: "04:30"},
        {value: "05:00", text: "05:00"},
        {value: "05:30", text: "05:30"},
        {value: "06:00", text: "06:00"},
        {value: "06:30", text: "06:30"},
        {value: "07:00", text: "07:00"},
        {value: "07:30", text: "07:30"},
        {value: "08:00", text: "08:00"},
        {value: "08:30", text: "08:30"},
        {value: "08:45", text: "08:45"},
        {value: "09:00", text: "09:00"},
        {value: "09:30", text: "09:30"},
        {value: "10:00", text: "10:00"},
        {value: "10:30", text: "10:30"},
        {value: "11:00", text: "11:00"},
        {value: "11:30", text: "11:30"},
        {value: "12:00", text: "12:00"},
        {value: "12:30", text: "12:30"},
        {value: "13:00", text: "13:00"},
        {value: "13:30", text: "13:30"},
        {value: "14:00", text: "14:00"},
        {value: "14:30", text: "14:30"},
        {value: "15:00", text: "15:00"},
        {value: "15:30", text: "15:30"},
        {value: "16:00", text: "16:00"},
        {value: "16:30", text: "16:30"},
        {value: "17:00", text: "17:00"},
        {value: "17:30", text: "17:30"},
        {value: "18:00", text: "18:00"},
        {value: "18:30", text: "18:30"},
        {value: "19:00", text: "19:00"},
        {value: "19:30", text: "19:30"},
        {value: "20:00", text: "20:00"},
        {value: "20:30", text: "20:30"},
        {value: "21:00", text: "21:00"},
        {value: "21:30", text: "21:30"},
        {value: "22:00", text: "21:00"},
        {value: "22:30", text: "22:30"},
        {value: "23:00", text: "23:00"},
        {value: "23:30", text: "23:30"},
      ],
      weekArr: [{text: 'Sunday', value: 'sunday'},
        {text: 'Monday', value: 'monday'},
        {text: 'Tuesday', value: 'tuesday'},
        {text: 'Wednesday', value: 'wednesday'},
        {text: 'Thursday', value: 'thursday'},
        {text: 'Friday', value: 'friday'},
        {text: 'Saturday', value: 'saturday'}],
      daysArr: [{text: '1', value: '1'}, {text: '2', value: '2'}, {text: '3', value: '3'}, {
        text: '4',
        value: '4'
      }, {text: '5', value: '5'}, {text: '6', value: '6'},
        {text: '7', value: '7'}, {text: '8', value: '8'}, {text: '9', value: '9'}, {
          text: '10',
          value: '10'
        }, {text: '11', value: '11'}, {text: '12', value: '12'},
        {text: '13', value: '13'}, {text: '14', value: '14'}, {text: '15', value: '15'}, {
          text: '16',
          value: '16'
        }, {text: '17', value: '17'}, {text: '18', value: '18'},
        {text: '19', value: '19'}, {text: '20', value: '20'}, {text: '21', value: '21'}, {
          text: '22',
          value: '22'
        }, {text: '23', value: '23'}, {text: '24', value: '24'},
        {text: '25', value: '25'}, {text: '26', value: '26'}, {text: '27', value: '27'}, {
          text: '28',
          value: '28'
        }, {text: '29', value: '29'}, {text: '30', value: '30'}, {text: '31', value: '31'},
        {text: 'First Sunday', value: 'first sunday'}, {
          text: 'First Monday',
          value: 'first monday'
        }, {text: 'First Tuesday', value: 'first tuesday'}, {
          text: 'First Wednesday',
          value: 'first wednesday'
        }, {text: 'First Thursday', value: 'first thursday'}, {
          text: 'First Friday',
          value: 'first friday'
        }, {text: 'First Saturday', value: 'first saturday'},
        //   { text: 'Second Sunday', value: 'second sunday' }, { text: 'Second Monday', value: 'second monday' }, { text: 'Second Tuesday', value: 'second tuesday' }, { text: 'Second Wednesday', value: 'second wednesday' }, { text: 'Second Thursday', value: 'second thursday' }, { text: 'Second Friday', value: 'second friday' }, { text: 'Second Saturday', value: 'second saturday' },
        //   { text: 'Third Sunday', value: 'third sunday' }, { text: 'Third Monday', value: 'third monday' }, { text: 'Third Tuesday', value: 'third tuesday' }, { text: 'Third Wednesday', value: 'third wednesday' }, { text: 'Third Thursday', value: 'third thursday' }, { text: 'Third Friday', value: 'third friday' }, { text: 'Third Saturday', value: 'third saturday' },
        //   { text: 'Fourth Sunday', value: 'fourth sunday' }, { text: 'Fourth Monday', value: 'fourth monday' }, { text: 'Fourth Tuesday', value: 'fourth tuesday' }, { text: 'Fourth Wednesday', value: 'fourth wednesday' }, { text: 'Fourth Thursday', value: 'fourth thursday' }, { text: 'Fourth Friday', value: 'fourth friday' }, { text: 'Fourth Saturday', value: 'fourth saturday' },
        //   { text: 'Fifth Sunday', value: 'fifth sunday' }, { text: 'Fifth Monday', value: 'fifth monday' }, { text: 'Fifth Tuesday', value: 'fifth tuesday' }, { text: 'Fifth Wednesday', value: 'fifth wednesday' }, { text: 'Fifth Thursday', value: 'fifth thursday' }, { text: 'Fifth Friday', value: 'fifth friday' }, { text: 'Fifth Saturday', value: 'fifth saturday' },
        //   { text: 'Last Sunday', value: 'last sunday' }, { text: 'Last Monday', value: 'last monday' }, { text: 'Last Tuesday', value: 'last tuesday' }, { text: 'Last Wednesday', value: 'last wednesday' }, { text: 'Last Thursday', value: 'last thursday' }, { text: 'Last Friday', value: 'last friday' }, { text: 'Last Saturday', value: 'last saturday' },
        {text: 'First Weekday', value: 'first weekday'}, {
          text: 'Last Weekday',
          value: 'last weekday'
        }, {text: 'Last Day', value: 'last day'}
      ],
      monthsArr: [{text: 'January', value: 'january'}, {text: 'February', value: 'february'}, {
        text: 'March',
        value: 'march'
      }, {text: 'April', value: "april"}, {text: 'May', value: 'may'},
        {text: 'June', value: 'june'}, {text: 'July', value: 'july'}, {
          text: 'August',
          value: 'august'
        }, {text: 'September', value: 'september'}, {text: 'October', value: 'october'}, {
          text: 'November',
          value: 'november'
        }, {text: 'December', value: 'december'}],
      designationsArr: [{text: 'Accounts Payable', value: 'Accounts Payable'}, {
        text: 'Operations',
        value: 'Operations'
      }],
      policyTypesArr: [{text: 'Physical', value: 'physical'}, {text: 'Liability', value: 'liability'}, {
        text: 'Both',
        value: 'both'
      }],
      // assetStatusArr:[{text:'ACTIVE',value:'Active'},{text:'IN GARAGE',value:'In Garage'},

      assetStatusArr: [
        {text: 'Active', value: 'Active'},
        {text: 'Customer', value: 'Customer'},
        {text: 'Internal', value: 'Internal'},
        {text: 'In Garage', value: 'In Garage'},
        {text: 'In Transit', value: 'In Transit'},
        {text: 'Ready', value: 'Ready'},
        {text: 'Make-Ready', value: 'Make-Ready'},
        {text: 'On-Hold', value: 'On-Hold'},
        {text: 'On-Order', value: 'On-Order'},
        {text: 'Sold', value: 'Sold'},
        {text: 'Void', value: 'Void'},
      ],
      campaignRecallVinClaimStatusArr: [
        {text: 'Open', value: 'open'},
        {text: 'Claim Pending', value: 'claim pending'},
        {text: 'Complete', value: 'complete'},
        {text: 'Expired', value: 'expired'},
      ],
      contractAllowanceArr: [{text: 'FEDERAL HIGHWAY USE TAX', value: 'FHU'},
        // {text:'INSURANCE',value:'INS'},{text:'APPORTION',value:'IRP'},
        {text: 'LICENSE', value: 'LIC'},
        //     {text:'VEHICLE PROPERTY TAX',value:'PTX'},{text:'HEAVY VEHICLE USE TAX',value:'HVUT'}
      ],
      reasonsArr: [
        {text: 'LEASE INTERIM', value: 'LSEINT'},
        {text: 'LEASE EXTRA', value: 'LSEXTR'},
        {text: 'SUBSTITUTE', value: 'SUBS'},
        {text: 'SUBS FOR DAMAGE NTLS CUST', value: 'SUBDAM'}

      ],
      vendorInvoiceTypesArr: [
        {text: 'Default', value: 'default'},
        {text: 'Item', value: 'item'},
        {text: 'Equipment', value: 'equipment'},
        // {text:'Sublet Invoice' , value:'sublet_invoice'}
      ],
      dispositionArr: [{text: 'Hold', value: 'hold'}, {text: 'Return', value: 'return'}, {
        text: 'Scrap',
        value: 'scrap'
      }],
      claimTypeArr: [{
        text: 'BASE | Standard Converages',
        code: 'base',
        description: 'standard converages',
        value: 'base'
      },
        {text: 'CAMP | Campaign', code: 'camp', description: 'campaign', value: 'camp'},
        {text: 'CHGBAC | Charge Back', code: 'chgbac', description: 'charge back', value: 'chgbac'},
        {text: 'DEALCH | Dealership Charge', code: 'dealch', description: 'dealership charge', value: 'dealch'},
        {text: 'DEALNC | Dealership No Charge', code: 'dealnc', description: 'dealership no charge', value: 'dealnc'},
        {text: 'EXTEND | Extended Coverage', code: 'extend', description: 'extended coverage', value: 'extend'},
        {text: 'INT | Internal VTRL Performed', code: 'int', description: 'internal vtrl performed', value: 'int'},
        {text: 'PDI | Pre Delivery Inspection', code: 'pdi', description: 'pre delivery inspection', value: 'pdi'},
        {text: 'PRTS | Parts Warranty', code: 'prts', description: 'parts warranty', value: 'prts'},
        {text: 'VENDOR | Vendor Performed', code: 'vendor', description: 'vendor performed', value: 'vendor'}],
      laborPricingTypeArr: [{text: "Customer Override", value: "customer_override"},
        {text: "Customer Class Override", value: "customer_class_override"},
        {text: "Customer/Contract Override", value: "customer_contract_override"},
        // {text: "Unit Override",value: "unit_override"},
        {text: "Location Override", value: "location_override"}],
      programTypeArr: [{text: 'D | Disposal', value: 'd'},
        {text: 'I | Inspection', value: 'i'},
        {text: 'M | Maintenance', value: 'm'}
      ],
      programCategoryArr: [{text: 'INSPEC | Inspection', value: 'inspec'},
        {text: 'MAINT | Maintenance', value: 'maint'},
        {text: 'SAFETY | Recalls', value: 'safety'}],
      intervalTypeArr: [{text: 'D | Days', value: 'd'},/*{text:'E | Expiry Date',value:'e'},*/{
        text: 'M | Metric',
        value: 'm'
      }, {text: 'N | Months', value: 'n'}
        , {text: 'O | Once', value: 'o'}
      ],
      programArr: [],
      contactMethodArr: [{text: 'Email', value: 'email'},
        {text: 'Print', value: 'print'},
        {text: 'Telephone', value: 'telephone'},
      ],
      toOptionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false
      },
      fromOptionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false
      },
      dateTimeConfigs: {
        start: {
          format: 'MM/DD/YYYY hh:mm:ss a',
          useCurrent: false,
          showClose: true
        },
        end: {
          format: 'MM/DD/YYYY hh:mm:ss a',
          useCurrent: false,
          showClose: true
        }
      },
      salesLocations: [
        {text: 'Used Truck Sales | Fontana', value: 'fontana'},
        {text: 'Used Truck Sales | Rancho Dominguez', value: 'rancho dominguez'},
        {text: 'Used Truck Sales | San Diego', value: 'san diego'},
        {text: 'Used Truck Sales | Arizona', value: 'arizona'},
      ],
      repModuleArr: [
        {text: 'Disposal', value: 'disposal'},
        {text: 'Customer', value: 'customer'},
        {text: 'Requisition', value: 'requisition'}
      ],
      accountingCodeArr: [
        {text: 'AR1 | ACCOUNTS RECEIVABLE-CO 001', value: 'AR1'},
        {text: 'AR2 | ACCOUNTS RECEIVABLE-CO 002', value: 'AR2'},
        {text: 'DS1 | A/R TRUCK SALES-CO 001', value: 'DS1'},
        {text: 'DS2 | A/R TRUCK SALES-CO 002', value: 'DS2'},
        {text: 'FIN | FINANCE CHARGES', value: 'FIN'}

      ],
      calendarTypesArr: [
        {text: "Leave", value: "leave"},
        {text: "Holiday", value: "holiday"}
      ],
      leaveTypesArr: [
        {text: "Annual Leave", value: "Annual Leave"},
        {text: "Leave WOP", value: "Leave WOP"},
        {text: "Other", value: "Other"},
        {text: "Personal Leave", value: "Personal Leave"},
        {text: "Weekly", value: "Weekly"}
      ],
      userTypesArr: [
        {text: "Entry", value: "entry"},
        {text: "Intermediate", value: "intermediate"},
        {text: "Senior", value: "senior"},
      ],
      vendorInvDocOptionalArr: [
        "001-50000457-000", "001-50000011-000", "001-50000017-000", "001-50000241-000", "001-50000258-000",
        "001-50000244-000", "001-50000246-000", "001-50000076-000", "001-50000569-000", "001-50000577-000",
        "001-50000249-000", "001-50000114-000", "001-50000251-000", "001-50000438-000", "001-50000252-000",
        "001-50000583-000", "001-50000255-000"
      ],
      chargeTypesArr: [
        {text: "AR", value: "ar"},
        {text: "CC", value: "cc"},
        {text: "CD", value: "cd"},
        {text: "CH", value: "ch"},
        {text: "CR", value: "cr"},
        {text: "I5", value: "i5"},
        {text: "MC", value: "mc"},
        {text: "RC", value: "rc"},
        {text: "RD", value: "rd"},
        {text: "RF", value: "rf"},
        {text: "RR", value: "rr"},
        {text: "RU", value: "ru"},
        {text: "RW", value: "rw"},
        {text: "UE", value: "ue"},
        {text: "WO", value: "wo"},
        {text: "XD", value: "xd"},
      ],
      delayTimer: null,
      zip_postal: "",
      state_province: "",
      zip_postal_type: "number",
      zip_postal_valid_length: 5,
      distance_unit: 'Miles',
      color_spelling: 'Color',
      labor_spelling: 'Labor',
      translator: null,
      updateKey: 0
    };
  },
  mounted: function () {
    // Close the dropdown if the user clicks outside of it
    window.onclick = function (event) {
      if (!event.target.matches('.dropbtn')) {
        var dropdowns = document.getElementsByClassName("dropdown-content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
          }
        }
      }
    }

    $(window).resize(function () {
      $('.vgt-responsive').height($(window).height() - 430);
    });

    var self = this;
    var path = window.location.pathname;
    var segments = path.split("/");

    // checking the region
    if(process.env.REGION === "US"){
      this.zip_postal = "Zip Code";
      this.state_province = "State";
      this.zip_postal_type = "number";
      this.zip_postal_valid_length = 5;
      this.distance_unit = "Miles";
      this.color_spelling = "Color";
      this.labor_spelling = "Labor";
    }else{
      this.zip_postal = "Postal Code";
      this.state_province = "Province";
      this.zip_postal_type = "text";
      this.zip_postal_valid_length = 6;
      this.distance_unit = "Kilometers";
      this.color_spelling = "Colour";
      this.labor_spelling = "Labour";
    }

    //check token if user came from rental
    var token = this.$route.query.token;
    if (token != undefined) {
      localStorage.setItem("tkn", token);
    }

    /* if Acces Token is not exits redirect to login page. */
    if (localStorage.getItem("tkn") == "" || localStorage.getItem("tkn") == null) {
      if (segments[1] != 'transport-request') {
        self.$router.push({name: "Login", path: "/", params: {redirect_url: path}});
        self.$root.$emit('redirect_to_login');
      }
    } else {
      var url = segments[1] + "/" + segments[2];
      //self.unSyncData(url)
    }
      setTimeout(() => {
          this.$nextTick(() => {
            if (!this.translator) {
              this.translator = new Translator(process.env.TRANSLATE_API, this);
            }
            this.translatePageOnLoad();
          });
        }, 2000);
  },
  beforeDestroy() {
    if(this.translator) {
      this.translator.stopObserving();
    }
  },
  directives: {
    cleave: {
      inserted: (el, binding) => {
        el.cleave = new Cleave(el, binding.value || {});

      },
      update: (el) => {

        const event = new Event('input', {bubbles: true});
        setTimeout(() => {
          if (el.cleave.properties.result != '') {
            el.value = el.cleave.properties.result;
            el.dispatchEvent(event);
          }
        }, 100);
      }
    }
  },
  methods: {
    async translatePageOnLoad() {
      const selectedLang = this.getSelectedLang(); // Get the selected language from localStorage
      if(!this.translator) {
        this.translator = new Translator(process.env.TRANSLATE_API, this); // Initialize the Translator class with the API key from environment variables
      }
      await this.translator.translatePage(selectedLang); // Translate the page when the component is loaded
    },
    // Helper method to get the selected language
    getSelectedLang() {
      return localStorage.getItem('selectedLang') || 'en'; // Default to 'en' if no language is selected
    },
    async translateTo(lang) {
      if (this.translator) {
        localStorage.setItem('selectedLang', lang);
        await this.translator.translatePage(lang);
      }
    },
    validateZipPostalCode(code) {
      // Remove all non-alphanumeric characters (including spaces)
      let cleaned = code.replace(/[^a-zA-Z0-9]/g, '');
      // For Canada, insert a space after the first 3 characters
      if (process.env.REGION === 'CA' && cleaned.length > 3) {
        cleaned = cleaned.slice(0, 3) + ' ' + cleaned.slice(3);
      }
      // Trim the result to max valid length
      if (cleaned.length > this.zip_postal_valid_length) {
        cleaned = cleaned.slice(0, this.zip_postal_valid_length);
      }
    
      return cleaned;
    },    
    formatZipPostalCodeForCA(code){
      if(code && code.includes(' ')){
        this.zip_postal_valid_length = 7;
      } else {
        this.zip_postal_valid_length = 6;
      }
    },
    nullcheckforString: function (str) {
      if (str == null) {
        return "";
      }
      return str;
    },
    leaveFocus: function (evt) {
      console.log("LeaveFocus");
      evt = (evt) ? evt : window.event;
      if (evt.target.value.indexOf(",") == -1) {
        console.log("IF");
        return this.amountFormat(evt.target.value);
      } else {
        console.log("ELSE");
        var amount = evt.target.value.replace(/\,/g, "");
        return this.amountFormat(amount);
      }
    },
    enterVal: function (evt) {
      evt = (evt) ? evt : window.event;
      var amount = evt.target.value.replace(/\,/g, "");
      return amount = evt.target.value;
    },
    removeFormat(amount, dollar = false) {
      console.log("AMOUNT =", amount);
      if (amount) {
        if (dollar === true) {
          console.log("dollar =", dollar);
          console.log(amount.toString().indexOf("$"));
          if (amount.toString().indexOf("$") != -1) {
            amount = amount.toString().replace("$", '');
          }
        }
        if (amount.toString().indexOf(",") == -1) {
          return parseFloat(amount);
        } else {
          return parseFloat(amount.replace(/\,/g, ""));
        }
      } else {
        if (dollar === true) {
          if (amount.toString().indexOf("$") != -1) {
            amount = amount.toString().replace("$", '');
          }
        }
        return parseFloat(amount);
      }
    },
    isPercentCheck: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;

      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
        evt.preventDefault();
      } else {
        // console.log("1==" , evt)
        // console.log("2==" , evt.key)
        console.log("3==", evt.target.value)
        // console.log("4==" , discountPer)
        if (evt.target.value > 99.99) {
          console.log("1==", evt.target.value)
          evt.preventDefault();
        } else {
          console.log("2==", evt.target.value)
          return true;
        }

      }
    },
    getNum(val) {
      if (isNaN(val)) {
        return 0;
      }
      return val;
    },
    isAmountCheck: function (evt, isEditable = true, val = 9999999) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      console.log(charCode);
      //handle - sign to enter only once
      if (charCode === 45 && evt.target.value.split('-').length > 1) {
        evt.preventDefault();
      }

      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1) && charCode !== 44 && charCode !== 45) {
        evt.preventDefault();
      } else {
        console.log("isEditable == ", isEditable);
        console.log("val == ", evt.target.value);
        if (evt.target.value > val) {

          evt.preventDefault();
        } else {
          if (isEditable === true) {
            return true;
          } else {
            evt.preventDefault();
          }

        }

      }
    },
    exportReports: function (actionFlag = "") {

      if (actionFlag != "") {
        this.action = actionFlag;
      } else {
        //check total records validation for export direct or with queue
        if (this.totalRecords > process.env.EXPORT_MAX) {
          alert("Export records more than " + process.env.EXPORT_MAX + " not allowed. Please filter your result.");
          return;
        }

        //if records are more than configured value than it will export using queue else direct export
        if (this.totalRecords > process.env.EXPORT_QUEUE) {
          alert("Total records are more than " + process.env.EXPORT_QUEUE + ", So your file will be scheduled in queue. You can download it from batch screen once it will be completed.")
          this.action = "export_queue";
        } else {
          this.action = "export";
        }
      }


      // this.loadList();
      //to load all existing filters while click on export
      this.loadFilters('load');
      EventBus.$emit("clearSelection", false);
    },
    exportEnrichReports: function (actionFlag = "") {

      if (actionFlag != "") {
        this.action = actionFlag;
      } else {
        //check total records validation for export direct or with queue
        if (this.totalRecords > process.env.EXPORT_MAX) {
          alert("Export records more than " + process.env.EXPORT_MAX + " not allowed. Please filter your result.");
          return;
        }

        //if records are more than configured value than it will export using queue else direct export
        if (this.totalRecords > process.env.EXPORT_QUEUE) {
          alert("Total records are more than " + process.env.EXPORT_QUEUE + ", So your file will be scheduled in queue. You can download it from batch screen once it will be completed.")
          this.action = "compare-with-enrich_queue";
        } else {
          this.action = "compare-with-enrich";
        }
      }


      // this.loadList();
      //to load all existing filters while click on export
      this.loadFilters('load');
      EventBus.$emit("clearSelection", false);
    },
    exportLineItemReports: function (actionFlag = "") {

      if (actionFlag != "") {
        this.action = actionFlag;
      } else {
        //check total records validation for export direct or with queue
        if (this.totalRecords > process.env.EXPORT_MAX) {
          alert("Export records more than " + process.env.EXPORT_MAX + " not allowed. Please filter your result.");
          return;
        }

        //if records are more than configured value than it will export using queue else direct export
        if (this.totalRecords > process.env.EXPORT_QUEUE) {
          alert("Total records are more than " + process.env.EXPORT_QUEUE + ", So your file will be scheduled in queue. You can download it from batch screen once it will be completed.")
          this.action = "export_line_item_queue";
        } else {
          this.action = "export_line_item";
        }
      }


      // this.loadList();
      //to load all existing filters while click on export
      this.loadFilters('load');
      EventBus.$emit("clearSelection", false);
    },

    redirectPageUrl: function (url) {
      var self = this;
      self.$router.push(url);
    },
    calculateActualInterests: function (
      loan_bal,
      fixed_pay,
      rate,
      term,
      payDate,
      isBalloon,
      stCount,
      start_date,
      rateType,
      days,
      type
    ) {
      var data = [];
      rate = rate / 100;
      var total_interest = 0.00;
      var total_principal_amount = 0.00;
      var note_bal = loan_bal;
      var prev_balance = loan_bal;
      var perDayRate = parseFloat(rate) / days;
      perDayRate = parseFloat(perDayRate.toFixed(11));
      payDate = new Date(payDate);
      var prev_month = new Date(start_date);
      for (let index = stCount; index < term; index++) {
        var month = payDate.getMonth();
        var diff_in_dates = payDate.getTime() - prev_month.getTime();
        var daysInMonth = diff_in_dates / 1000 / 60 / 60 / 24;
        // 2. per_day_rate * day_of_month = monthly_rate
        if (rateType == 'Variable') {
          daysInMonth += 1;
        }

        var daysForCalculation = daysInMonth;
        if (type === 30) {
          daysForCalculation = 30
        }
        var monthly_rate = perDayRate * daysForCalculation;
        // 3. loand_amount * monthly_aate / 100 = interest
        var interest_accrued = prev_balance * monthly_rate;
        var inter = interest_accrued.toFixed(2);

        // Following conditional ends up with an extra day of interests that throws
        // all results off
        // if(index == 0) {
        // var diffMonth = this.monthDiff(new Date(start_date), new Date(payDate));
        // if (diffMonth > 0) {
        //   var postPay = parseFloat(inter) * diffMonth;
        //   inter = postPay.toFixed(2);
        // }
        //     var date1 = new Date(start_date);
        //     var date2 = new Date(payDate);
        //     var diffDays = date2.getTime() - date1.getTime();

        //     var Difference_In_Days = diffDays / (1000 * 3600 * 24);
        //     //if rate type is variable then add 1 more days
        //     if (rateType == 'Variable'){
        //         Difference_In_Days += 1;
        //     }
        //     if (Difference_In_Days > 0){
        //         var start_date = new Date(payDate);
        //         var daysInStartMonth = new Date(start_date.getFullYear(), month, 0).getDate();

        //         var intrestRemain = Difference_In_Days / daysInStartMonth;
        //         var postPay = parseFloat(inter) * intrestRemain;
        //         inter = postPay.toFixed(2);
        //     }
        // }

        // 4. fixed_pay  - interest = principal_pay
        var principal_amount = fixed_pay - parseFloat(inter);

        total_principal_amount += principal_amount;
        total_interest += parseFloat(inter);

        // 5. Loan_bal - principal_pay - note_bal
        prev_month = new Date(payDate);
        note_bal = note_bal - principal_amount;
        prev_balance = note_bal;

        if (index == term - 1 && !isBalloon && note_bal < 0) {
          note_bal = 0;
        }

        data.push({
          date: this.GetFormattedDate(payDate),
          count: index + 1, rate: monthly_rate, principal_pay: principal_amount.toFixed(2),
          intereset: inter,
          note_bal: note_bal.toFixed(2)
        });
        payDate.setMonth(month + 1);
      }

      if (isBalloon) {
        payDate = new Date(payDate);
        var month = payDate.getMonth();

        payDate.setMonth(month + 1);


        var daysInMonth = new Date(payDate.getFullYear(), month, 0).getDate();
        // 2. per_day_rate * day_of_month = monthly_rate
        var monthly_rate = perDayRate * daysInMonth;

        var interest = ((note_bal * monthly_rate) / 100);
        var inter = interest.toFixed(2);

        var finalNoteBal = 0;

        data.push({
          date: this.GetFormattedDate(payDate),
          count: parseInt(term) + 1, rate: monthly_rate, principal_pay: note_bal.toFixed(2),
          intereset: inter, note_bal: finalNoteBal.toFixed(2)
        });

        total_interest += interest;
        note_bal = 0;
      }

      data.push({
        interest: total_interest.toFixed(2),
        principal: total_principal_amount.toFixed(2),
        residual: note_bal.toFixed(2)
      });

      return data;
    },
    interest_actual_360: function (loan_bal, fixed_pay, rate, term, payDate, isBalloon, stCount, start_date, rateType) {
      var data = this.calculateActualInterests(
        loan_bal,
        fixed_pay,
        rate,
        term,
        payDate,
        isBalloon,
        stCount,
        start_date,
        rateType,
        360,
        'actual'
      );
      return data;
    },
    interest_actual_365: function (
      loan_bal,
      fixed_pay,
      rate,
      term,
      payDate,
      isBalloon,
      stCount,
      start_date,
      rateType
    ) {
      var data = this.calculateActualInterests(
        loan_bal,
        fixed_pay,
        rate,
        term,
        payDate,
        isBalloon,
        stCount,
        start_date,
        rateType,
        365,
        'actual'
      );
      return data;
    },
    interest_30_365: function (loan_bal, fixed_pay, rate, term, payDate, isBalloon, stCount, start_date, rateType) {
      var data = this.calculateActualInterests(
        loan_bal,
        fixed_pay,
        rate,
        term,
        payDate,
        isBalloon,
        stCount,
        start_date,
        rateType,
        365,
        30
      );
      return data;
    },
    interest_30_360: function (loan_bal, fixed_pay, rate, term, payDate, isBalloon, stCount, start_date, rateType) {
      var data = this.calculateActualInterests(
        loan_bal,
        fixed_pay,
        rate,
        term,
        payDate,
        isBalloon,
        stCount,
        start_date,
        rateType,
        360,
        30
      );
      return data;
    },
    GetFormattedDate: function (todayTime) {
      // var todayTime = new Date();
      var month = todayTime.getMonth() + 1;
      var day = todayTime.getDate();
      var year = todayTime.getFullYear();
      return month + "/" + day + "/" + year;
    },
    monthDiff: function (d1, d2) {
      var months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months;
    },

    selectionChanged(param) {
      var self = this;
      self.serverParams.selectedAll = false;
      if (param.selectedRows.length == 100) {
        EventBus.$emit('clear-selection', false);
      } else {
        EventBus.$emit('clear-all-flags', false);
      }
      return;
    },
    onStartDateTimeChange(e) {
      this.$set(this.dateTimeConfigs.end, 'minDate', e.date);
    },
    onEndDateTimeChange(e) {
      this.$set(this.dateTimeConfigs.start, 'maxDate', e.date);
    },
    onStartChange(e) {
      this.$set(this.toOptionsDate, 'minDate', e.date);
    },
    onEndChange(e) {
      this.$set(this.fromOptionsDate, 'maxDate', e.date);
    },


    addNewCity: function () {

      var self = this;
      var error = false;
      self.city_error_msg = "";

      if (self.state != null && self.state != 0) {

        self.canAddCity = true;
      } else {

        self.city_error_msg = "Please select the state first!!";
        error = true;
      }

    },

    goPreviousPath() {
      var getPreviousListPath = JSON.parse(localStorage.getItem("previousListPath"))
      var previousPath = JSON.parse(localStorage.getItem("previousPath"));
      var backModule = JSON.parse(localStorage.getItem("backModule"));
      var currentModule = JSON.parse(localStorage.getItem("currentModule"));
      // var lastPath = JSON.parse(localStorage.getItem("lastPath"));
      // var newTab = JSON.parse(localStorage.getItem("newTab"));
      if ((currentModule == 'workorder' || currentModule == "customer-estimate" || currentModule == "vendor-estimate") && window.location.pathname.includes("create")) {
        if (localStorage.getItem("newAsset") != undefined && localStorage.getItem("newAsset") != null) {
          localStorage.removeItem("newAsset");
        }
        if (localStorage.getItem("newCustomer") != undefined && localStorage.getItem("newCustomer") != null) {
          localStorage.removeItem("newCustomer");
        }
      }

      if (backModule != currentModule && (backModule != "" && backModule != null)) {
        if (!window.location.pathname.includes("edit") && !window.location.pathname.includes("create") && !window.location.pathname.includes("add")) {
          localStorage.setItem('backModule', JSON.stringify(""))
          this.$router.push({path: previousPath})
        } else {
          this.$router.go(-1)
        }
      } else {
        // var currentPage = window.location.pathname.split('/');
        // var lastPage = lastPath.split('/');
        if (!window.location.pathname.includes("edit") && !window.location.pathname.includes("create") && !window.location.pathname.includes("add")) {
          this.$router.push({path: getPreviousListPath})

          // if (!lastPath.includes('edit') && !lastPath.includes('create') && !lastPath.includes('add')) {
          //     console.log("if includes edit")
          //     if (currentPage[1] === lastPage[1]) {
          //         this.$router.go(-1)
          //     }
          //     else {
          //         this.$router.push({ path: newTab })
          //     }

          // }
          // else {
          //     console.log("current ", window.location.pathname, "last", lastPath)

          //     if (currentPage[1] === lastPage[1]) {
          //         this.$router.push({ path: getPreviousListPath })
          //     }
          //     else {
          //         this.$router.go(-1)
          //     }

          // }
        } else {
          this.$router.go(-1)
        }
      }
    },
    getRecentlyPagesMethod(storeObject) {
      var visitedPath = [];

      // get current window path and add to visitedPath list.

      visitedPath.push(storeObject)

      // getPages object is used to store pages from localStorage data.
      var getPages = [];
      var fetchedObject = localStorage.getItem('visited_page');
      console.log(fetchedObject)
      if (fetchedObject != null) {
        getPages = JSON.parse(fetchedObject)

        // check not null condition, if localStorage has visited page data, then store to list.
        if (getPages != null) {
          for (var list = 0; list < getPages.length; list++) {
            visitedPath.push(getPages[list])
          }
        }
      }
      var filterVisitedPath = [];
      filterVisitedPath = visitedPath.filter((visitedPath, idx) => idx < 10)
      // set all visited path to the localStorage.
      localStorage.setItem('visited_page', JSON.stringify(filterVisitedPath));
      // localStorage.setItem("visited_page", )
      EventBus.$emit("visited_page");
    },

    changeTime12To24Hrs(twelveHr) {

      if (twelveHr != null && twelveHr != "" && twelveHr != '__:__ am' && twelveHr != '__:__ pm') {

        var hrs = Number(twelveHr.match(/^(\d+)/)[1]);
        var mnts = Number(twelveHr.match(/:(\d+)/)[1]);
        var format = twelveHr.match(/\s([^\s]*)$/)[1];

        if (format == "pm" && hrs < 12) hrs = hrs + 12;
        if (format == "am" && hrs == 12) hrs = hrs - 12;

        var hours = hrs.toString();
        var minutes = mnts.toString();
        if (hrs < 10) hours = "0" + hours;
        if (mnts < 10) minutes = "0" + minutes;
        return hours + ":" + minutes + ":00";

      }
    },

    openDocument(doc_path, extension) {

      var self = this;
      var file = "";
      if (extension && (
        extension == 'png' ||
        extension == 'jpeg' ||
        extension == 'jpg' ||
        extension == 'pdf' ||
        extension == 'doc' ||
        extension == 'docx' ||
        extension == 'webp' ||
        extension == 'mp4' ||
        extension == 'mkv' ||
        extension == 'avi' ||
        extension == 'webm' ||
        extension == 'ogv'
      )) {
        file = doc_path;
      } else {
        file = self.googleUrl + doc_path;
      }


      var save = document.createElement('a');
      save.href = file;
      //save.download = file;
      save.target = '_blank';
      document.body.appendChild(save);
      save.click();
      document.body.removeChild(save);
    },

    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    myFunction() {
      //console.log('hello');
      $("#myDropdown").toggle("show");
    },
    validatePriceInput: function (evt) {
      evt = (evt) ? evt : window.event;
      if (evt.target.value > 999999.99) {
        EventBus.$emit('price-exide', true);
      } else {
        EventBus.$emit('price-exide', false);
      }
    },
    isNumber: function (evt) {

      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf(
        '.') != -1)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    unSyncData: function (url) {

      var self = this;

      if (url == 'reservation/list' || url == 'asset/list' || url == 'customer/list' || url == 'payment/list' || url == "unsync/detail") {
        // console.log(url);
      } else {

        $.ajax({
          url: process.env.ROOT_API + "/get-unsync-count",
          type: "GET",
          headers: this.ajxHeaders,
          dataType: 'json',
          success: function (data) {

            if (data.status == 'success') {
              if (data.content.customer_count < 1 && data.content.payments_count < 1 && data.content.reservation_count < 1) {
                self.flashit_flag = true;
                EventBus.$emit("user-flashit", self.flashit_flag);
              } else {
                EventBus.$emit("user-flashit", self.flashit_flag);
              }

            }
          },
          error: function (jqXHR, exception) {
            self.generateStatusCodeMessage(jqXHR, true, 'mixin-get-sync-count')
            /*if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");
                                    self.$router.push("/");
                                }
                                self.error = jqXHR.responseJSON.message;
                            }*/
          }
        });
      }
    },

    getPermissions: function () {

      if (localStorage.getItem("tkn") != "" && localStorage.getItem("tkn") != null) {

        var self = this;
        var build = localStorage.getItem('build_version');
        $.ajax({
          url: process.env.ROOT_API + "/user/permission",
          type: "POST",
          headers: this.ajxHeaders,
          dataType: 'json',
          success: function (data) {

            // self.exportFilteredFlag = false;
            if (data.status == 'success') {

              self.cantAccessPage = false;
              self.permissions = data.content;
              EventBus.$emit("user-permissions", self.permissions);
            }
            //check build version
            if (build && build != "undefined") {

              if (data.version != build) {
                localStorage.setItem('build_version', data.version);
                location.reload(true);
              }

            } else {

              localStorage.setItem('build_version', data.version);
            }

            localStorage.setItem("cache_enabled", data.cacheEnabled);

          },
          error: function (jqXHR, exception) {
            self.generateStatusCodeMessage(jqXHR, false, 'mixin-get-permission')
            /*if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");
                                    window.location.replace("/");
                                    //self.$router.push("/");
                                }
                                self.error = jqXHR.responseJSON.message;
                            }*/
          }
        });
      }
    },

    searchField(loading, search, flag, contractWiseAssetId, assetCustomerId = null, orderObj = null, index = null) {

      var self = this;

      if (self.delayTimer) {
        clearTimeout(self.delayTimer);
      }
      self.delayTimer = setTimeout(function () {
        self.searchFieldVal(loading, search, flag, contractWiseAssetId, assetCustomerId, orderObj, index);
      }, 1000);

    },

    validateLength(value, minLength, maxLength) {
      if (value.length < minLength) {
        return `Must be at least ${minLength} characters long`;
      }
      if (value.length > maxLength) {
        return `Must be no more than ${maxLength} characters long`;
      }
      return null; // Return null if there are no errors
    },

    searchFieldVal(loading, search, flag, contractWiseAssetId, assetCustomerId, orderObj, index) {

      var self = this;

      // if ( self.reqInProcess == 1 ) {
      //     setTimeout(function(){
      //         self.searchField(loading, search, flag, contractWiseAssetId);
      //     }, 2000);
      //     return;
      // }

      var stateId = "";
      if (self.state != null) {
        stateId = self.state.value;
      }
      if (flag == 'city-other') {
        stateId = self.shipToRows[index].state.value;
      }
      var vendorId = "";
      if (self.vendor != null) {
        vendorId = self.vendor.value;
      }
      var parentId = "";
      if (self.parent != null) {
        parentId = self.parent.value;
      }
      var customerId = "";
      if (self.customer != null) {
        customerId = self.customer.value;
      }

      var vehicleId = "";
      if (self.vehicle != null) {
        vehicleId = self.vehicle.value;
      }

      var contractId = "";
      if (self.contract != null) {
        contractId = self.contract.value;
      }

      var userId = "";
      if (self.user != null) {
        userId = self.user.value;
      }

      var model_id = "";
      if (self.model_code != null) {
        model_id = self.model_code.value;
      }

      var asset_pool_id = "";
      if (self.asset_pool_id != null) {
        asset_pool_id = self.asset_pool_id.value;
      }

      var gl_account = "";
      if (self.gl_account != null) {
        gl_account = self.gl_account.value;
      }

      var truck_type = '';
      // if (self.truckType != undefined && self.truckType.value != undefined && self.truckType.value > 0){
      //     truck_type = self.truckType.value;
      // }
      // if (self.requested_vehicle_type_id != undefined && self.requested_vehicle_type_id != null && self.requested_vehicle_type_id.value){
      //     truck_type = self.requested_vehicle_type_id.value;
      // }

      self.reqInProcess = 1;

      if (flag == 'vehicle_registration') {
        customerId = contractWiseAssetId;
        contractWiseAssetId = '';
      }
      $.ajax({
        url: process.env.ROOT_API + "/search",
        type: "post",
        crossDomain: true,
        headers: this.ajxHeaders,
        data: {
          search: search,
          flag: flag,
          stateId: stateId,
          vendorId: vendorId,
          parentId: parentId,
          customerId: customerId,
          vehicleId: vehicleId,
          contractId: contractId,
          userId: userId,
          contractWiseAssetId: contractWiseAssetId,
          model_id: model_id,
          asset_pool_id: asset_pool_id,
          gl_account: gl_account,
          truck_type: truck_type,
          assetCustomerId: assetCustomerId,
          orderObj: orderObj,
        },
        dataType: "json",
        success: function (data) {

          self.reqInProcess = 0;

          if (data.status == "success") {
            if (loading == "loading") {

            } else {
              loading(false);
            }

            if (flag == "state") {
              self.stateArr = data.content;
            }
            if (flag == "state-other") {
              self.shipToRows[index].stateArr = data.content;
            }
            if (flag == "technician") {
              self.techArr = data.content;
            }
            if (flag == "city") {
              self.cityArr = data.content;
            }
            if (flag == "city-other") {
              self.shipToRows[index].cityArr = data.content;
            }
            if (flag == "warranty") {
              self.warrantyArr = data.content;
            }
            if (flag == "vmrs") {
              self.vmrsArr = data.content;
            }
            if (flag == "vendor" || flag == "vendor_financier" || flag == "assignee") {
              self.vendorArr = data.content;
            }
            if (flag == "bill_vendor") {
              self.vendorArr = data.content;
              self.assigneeArr = data.content;
            }
            if (flag == "parent") {
              self.parentArr = data.content;
            }
            //to populate customer term, due date, location
            if (flag == "customer" || flag == "customer national lease") {
              self.customerArr = data.content;
              if (self.customerArr.length == 0) {
                self.isCustomerNotFound = true;
              } else {
                self.isCustomerNotFound = false;
              }
            }
            if (flag == "primeCustomer") {
              self.primeCustomerArr = data.content;
            }
            if (flag == "dealer") {
              self.dealerArr = data.content;
            }
            if (flag == "dealer_id") {
              self.dealer_id = data.content[0];
            }
            if (flag == "consumer") {
              self.consumerArr = data.content;
            }
            //to populate work order customer term, due date, location
            if (flag == "work_order_customer") {
              self.customerArr = data.content;
              if (self.customerArr.length == 0) {
                self.isCustomerNotFound = true;
              } else {
                self.isCustomerNotFound = false;
              }
            }
            if (flag == "vehicle" || flag == "permit_vehicle" || flag == "owned vehicle" || flag == "available_vehicles" || flag == "vehicle_registration") {
              self.vehicleArr = data.content;
              if (loading == "loading") {
                self.loading = false;
                self.vehicle_id = self.vehicleArr[0];
              }
              if (self.vehicleArr.length == 0) {
                self.isAssetNotFound = true;
              } else {
                self.isAssetNotFound = false;
              }
            }
            if (flag == "reason") {
              self.reasonArr = data.content;
              if (self.reasonArr.length == 0) {
                self.isReasonNotFound = true;
              } else {
                self.isReasonNotFound = false;
              }
            }
            if (flag == "labor_srt") {
              self.srtArr = data.content;
            }
            if (flag == "vehicle_vin" || flag == 'vehicle_vin_warranty') {
              self.vinArr = data.content;
              if (self.vinArr.length == 0) {
                self.isAssetNotFound = true;
              } else {
                self.isAssetNotFound = false;
              }
            }
            if (flag == "lease vehicle") {
              self.vehicleArr = data.content;
              if (self.vehicleArr.length == 0) {
                self.isAssetNotFound = true;
              } else {
                self.isAssetNotFound = false;
              }
            }
            if (flag == "contract") {
              self.contractArr = data.content;
            }
            if (flag == "location") {
              self.locationArr = data.content;
            }
            if (flag == "component" || flag == 'default component' || flag == 'vendor_item_number' || flag == "part_number") {
              self.componentArr = data.content;
            }
            if (flag == "item") {
              self.itemArr = data.content;
            }
            if (flag == "vendor_part_number") {
              self.vendorPartArr = data.content;
            }
            if (flag == "available component" || flag == "exist component" || flag == "default exist component") {
              self.componentArr = data.content;
            }
            if (flag == "rsb") {
              self.rsbArr = data.content;
            }
            if (flag == "failed_part_positions") {
              self.positionArr = data.content;
            }
            if (flag == "ev_part_bin") {
              self.binArr = data.content;
            }
            if (flag == "warehouse component") {
              self.componentArr = data.content;
            }
            if (flag == "component_category") {
              self.componentCategoryArr = data.content;
            }
            if (flag == "user") {
              self.userArr = data.content;
            }
            if (flag == "active vehicle") {
              self.vehicleArr = data.content;
              if (self.vehicleArr.length == 0) {
                self.isAssetNotFound = true;
              } else {
                self.isAssetNotFound = false;
              }
            }
            if (flag == "active lease vehicle") {
              self.leaseVehicleArr = data.content;
            }
            if (flag == "search vehicle for chart") {
              self.vehicleArr = data.content;
            }
            if (flag == "vehicle_model") {
              self.modelcodeArr = data.content;
            }
            if (flag == "vehicle_pool") {
              self.assetpoolArr = data.content;
            }

            if (flag == "purchase_order") {
              self.purchaseOrderArr = data.content;
            }

            if (flag == "reservation") {
              self.reservationArr = data.content;
            }

            if (flag == "lease_reservation") {
              self.reservationArr = data.content;
            }

            if (flag == "insurance company") {
              self.insuranceCompanyArr = data.content;
            }
            if (flag == "insurance agency") {
              self.insuranceAgencyArr = data.content;
            }
            if (flag == "rental_agreement") {
              self.rentalAgreementArr = data.content;
            }
            if (flag == 'active_rental_agreement') {
              self.rentalAgreementArr = data.content;
            }
            if (flag == "recall") {
              self.recallArr = data.content;
            }
            if (flag == "customer_purchase_order" || flag == "customer_purchase_order_asset") {
              self.customerPurchaseOrderArr = data.content;
            }
            if (flag == "invoice") {
              self.invoiceArr = data.content;
            }
            if (flag == "bill") {
              self.billArr = data.content;
            }
            if (flag == "vehicle_manufacturer") {
              self.vehicleManufacturerArr = data.content;
            }
            if (flag == "extraFeature") {
              self.featureArr = data.content;
            }
            if (flag == "accounts") {
              self.accountsArr = data.content;
            }
            if (flag == "je_accounts") {
              self.accountsArr = data.content;
            }
            if (flag == "accounts filter") {
              self.accountsFilterArr = data.content;
            }
            if (flag == "payment tags") {
              self.paymentTagsArr = data.content;
            }
            if (flag == "fuel island product") {
              self.productArr = data.content;
            }
            if (flag == "expense accounts") {
              self.expenseAccountsArr = data.content;
            }
            if (flag == "revenue accounts") {
              self.revenueAccountsArr = data.content;
            }
            if (flag == "active contract") {
              self.activeContractsArr = data.content;
            }
            if (flag == "bill item") {
              self.billItemArr = data.content;
            }
            if (flag == "work order component") {
              self.woCompArr = data.content;
            }
            if (flag == "wo_item") {
              self.woItemArr = data.content;
            }
            if (flag == "program") {
              self.programArr = data.content;
            }
            if (flag == "base_scope") {
              self.baseScopeArr = data.content;
            }
            if (flag == "gl_account") {
              self.glAccountArr = data.content;
            }
            if (flag == "liability accounts") {
              self.liabilityAccountsArr = data.content;
            }
            if (flag == "estimate") {
              self.estimateArr = data.content;
            }
            if (flag == "active vehicle status") {
              self.vehicleArr = data.content;
              if (self.vehicleArr.length == 0) {
                self.isAssetNotFound = true;
              } else {
                self.isAssetNotFound = false;
              }
            }
            if (flag == "active rental vehicle status") {
              self.vehicleArr = data.content;
              if (self.vehicleArr.length == 0) {
                self.isAssetNotFound = true;
              } else {
                self.isAssetNotFound = false;
              }
            }
            if (flag == "work_order") {
              self.workOrderArr = data.content;
            }
            if (flag == "asset_estimates") {
              self.estimateArr = data.content;
            }
            if (flag == "gl_with_charge") {
              self.chargeGlArr = data.content;
            }
          }
          if (flag == 'vendor invoice' || flag == 'paid vendor invoice') {
            self.voucherArr = data.content;
          }
          if (flag == 'paid vendor payment') {
            self.paymentArr = data.content;
          }
          if (flag == 'jv_number' || flag == 'jv_number_all') {
            self.jvArr = data.content;
          }
          if (flag == 'bank sequence') {
            self.sequenceArr = data.content;
          }
          if (flag == 'billCusId') {
            self.billCusIdArr = data.content;
          }
          if (flag == 'warranty_user') {
            self.warrantyUsers = data.content;
          }
          if (flag == 'rizon_technical_support_user') {
            self.assignedToArr = data.content;
          }
          if (flag == 'user_consumers') {
            self.consumerArr = data.content;
          }

        },

        error: function (jqXHR, exception) {

          //self.CheckBtn = 'Check';
          self.generateStatusCodeMessage(jqXHR, false, 'mixin-common-search')
          /*if (jqXHR.status == 0) {
                            self.error = "Remote server cannot be reached";
                        } else {
                            self.error = jqXHR.responseJSON.message;
                        }*/
        }
      });

    },
    //make first letter capital
    titleCase(str) {
      if (str == null) {
        return;
      } else {
        var value = str.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    },
    //make sentence first letter capital
    ucString(data) {
      var self = this;
      var value = data.replace(/_/g, " ");
      var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
      });
      return upp;
    },
    capitalize(str) {
      if (str == null) {
        return;
      } else {
        var value = str.toString()
        return value.toUpperCase();
      }
    },
    //date time format for datepicker
    getDateTimeFormat(dateTimeFormat) {

      var format = dateTimeFormat.split(" ");

      var date_format, time_format, ampm_format;
      if (format.length == 1) {
        date_format = format[0];
      } else if (format.length == 2) {
        date_format = format[0];
        time_format = format[1];
      } else if (format.length == 3) {
        date_format = format[0];
        time_format = format[1];
        ampm_format = format[2];
      }

      if (date_format != null) {

        if (date_format.includes("m")) {
          date_format = date_format.replace("m", "MM");
        }

        if (date_format.includes("d")) {
          date_format = date_format.replace("d", "DD");
        }

        if (date_format.includes("Y")) {
          date_format = date_format.replace("Y", "YYYY");
        }

        format = date_format;
      }

      if (time_format != null) {

        if (time_format.includes("H")) {
          time_format = time_format.replace("H", "HH");
        }

        if (time_format.includes("h")) {
          time_format = time_format.replace("h", "hh");
        }

        if (time_format.includes("i")) {
          time_format = time_format.replace("i", "mm");
        }

        if (time_format.includes("s")) {
          time_format = time_format.replace("s", "ss");
        }

        format += " " + time_format;
      }

      if (ampm_format != null) {
        format += " " + ampm_format;
      }

      console.log(format);
      return format;

    },
    getTodayDate() {
      var today = new Date();
      var yyyy = today.getFullYear();
      var mm = today.getMonth() + 1;
      var dd = today.getDate();

      if (mm < 10) {
        mm = "0" + mm;
      }

      if (dd < 10) {
        dd = "0" + dd;
      }

      var todayDate = mm + "/" + dd + "/" + yyyy;
      return todayDate;
    },
    generateStatusCodeMessage(jqxhr, hasSubmodule, msgId = '') {

      var self = this;

      if (jqxhr.status == 0) {
        self.errorMsg = "Remote server cannot be reached";
      } else {
        //redirect to login page if user not authenticated
        if (jqxhr.status == 401) {
          //clear previous data
          localStorage.removeItem("user_obj");
          localStorage.removeItem("tkn");
          self.$router.push("/");
          self.$root.$emit('redirect_to_login');
        } else if (jqxhr.status == 403) {
          if (hasSubmodule == true) {
            self.errorMsg = " Sorry!, You don't have permission to access this page.";

          } else {
            self.cantAccessPage = false;
            self.errorMsg = " Sorry!, You don't have permission to access this page.";
          }

        } else if (jqxhr.status == 400) {
          self.errorMsg = jqxhr.responseJSON.message;
        } else {
          // Error Like 500
          self.errorMsg = jqxhr.responseJSON.message;
        }
      }

      if (msgId == 'one-bank-receipt-transfer-item' || msgId == 'security-deposit-bank-receipt' || msgId == 'map-on-account-receipt' || msgId == 'map-on-cash-receipt' || msgId == 'map-specific-receipt-bank' || msgId == 'gross-invoice-map-bank' || msgId == 'cancel_receipt_payment') {
        setTimeout(function () {
          $(".errorLeft").each(function () {


            if ($(this).css('display') != 'none') {

              if (self.errorMsg != '' && msgId != "") {
                $(this).find('.alert-danger').show();
                if ($("#" + msgId).length != 0) {

                } else {
                  if ($(this).find('.alert-danger').length !== 0) {
                    if ($("#" + msgId).length == 0) {
                      $(".addmessage").append('<li id="' + msgId + '">' + self.errorMsg + '</li>')
                    }

                  } else {

                    $(this).prepend('<div class="alert alert-danger fade show " id="alertBackend"><button type="button" class="close close-alert" onclick="$(this).parent().remove()">×</button><ul class="addmessage" ><li id="' + msgId + '">' + self.errorMsg + '</li></ul></div>');

                  }
                }

              }

            }
          });
        }, 500);
      } else {
        setTimeout(function () {
          $(".admin-page-content").each(function () {


            if ($(this).css('display') != 'none') {

              if (self.errorMsg != '' && msgId != "") {
                $(this).find('.alert-danger').show();
                if ($("#" + msgId).length != 0) {

                } else {
                  if ($(this).find('.alert-danger').length !== 0) {
                    if ($("#" + msgId).length == 0) {
                      $(".addmessage").append('<li id="' + msgId + '">' + self.errorMsg + '</li>')
                    }

                  } else {

                    var alertHtml = '<div class="alert alert-danger fade show" id="alertBackend">' +
                      '<button type="button" class="close close-alert" onclick="$(this).parent().remove()">×</button>' +
                      '<ul class="addmessage"><li id="' + msgId + '">' + self.errorMsg + '</li></ul>' +
                      '</div>';

                    // Create a jQuery object for the alert HTML
                    var $alert = $(alertHtml);

                    // Check if msgId and add margin-top if true
                    if (msgId === 'warranty-claim-create') {
                      $alert.css('margin-top', '15px');
                    }

                    // Prepend the alert to the target element
                    $(this).prepend($alert);
                  }
                }

              }

            }
          });
        }, 500);
      }

      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    errorValidationFocus() {
      setTimeout(function () {
        $(".d-error,.field-error").each(function () {
          var current_element = $(this).text();
          if (current_element != '') {
            $([document.documentElement, document.body]).animate({
              scrollTop: $(this).offset().top - 300
            }, 500);
            // $(this).siblings( ".form-control" ).focus();
            $(this).parent().find('input').focus();
            return false;
          }
        });
        $(".c-error").each(function () {
          var current_element = $(this).text();
          if (current_element != '') {
            $([document.documentElement, document.body]).animate({
              scrollTop: $(this).offset().top - 300
            }, 500);
            // $(this).siblings( ".form-control" ).focus();
            $(this).parent().find('input').focus();
            return false;
          }
        });

      }, 500)
    },
    //allow to enter only integer values
    isIntegerCheck: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    arrayMoveElement(arr, fromIndex, toIndex) {
      var element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
    },
    formatPhoneNumber(phoneNumberString) {
      var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
      var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
      if (match) {
        return match[1] + '-' + match[2] + '-' + match[3]
      }
      return '';
    },
    amountFormat(amount, decPoint = 2) {
      // Remove commas from the amount if present
      if (amount && String(amount).includes(',')) {
        amount = String(amount).replaceAll(',', '');
      }

      // Parse the amount to a float
      amount = parseFloat(amount);
      amount = amount.toFixed(2);

      return amount;
    },
    // function for changing amount format to float
    amountFormatToFloat(amount) {

      if (typeof amount === 'string' && amount.trim() === "") {
        return 0; // Return 0 if the string is empty or only contains whitespace
      } else if (typeof amount === 'string') {
        // Preserve the negative sign and Remove any non-numeric or non-decimal characters
        let cleanAmount = amount.replace(/[^0-9.-]/g, "")

        // Check if the value contains decimal places
        if (cleanAmount.includes('.')) {
          return cleanAmount;
        } else {
          return parseInt(cleanAmount, 10) || 0; // Return integer if no decimal point
        }
      } else {
        return amount;
      }
    },
    customFunctionForAmountFormat(amount) {
      if (amount !== '' && amount !== '$') {
        let value;

        // Handle string amounts
        if (typeof amount === 'string') {
          value = amount.replace('$', '').trim();

          // Check if the string ends with a decimal (e.g., "20.")
          const endsWithDecimal = value.endsWith('.');

          // Convert the value to a float if it doesn't end with a decimal
          if (!endsWithDecimal) {
            // Allow single trailing 0 like "15.0" while typing
            if ((/\.\d*0$/.test(value)) && !/\.\d*[1-9]/.test(value)) {
              // If there are two or more trailing zeros, assume it's done
              if (/\.0{2,}$/.test(value)) {
                return value;
              }
              return value; // let "15.0" stay
            }
            // Check if the value is a whole number
            const isWholeNumber = Number(value) === Math.floor(value);

            // If it's a whole number, avoid adding decimal places
            if (isWholeNumber) {
              return Math.floor(value);
            }

            return this.amountFormatToFloat(value);
          } else {
            // Return the value as is (with the decimal at the end) for edge cases like "20."
            return value;
          }
        } else {
          // Handle non-string values
          value = amount;

          // Check if the value is a whole number
          const isWholeNumber = Number(value) === Math.floor(value);

          if (isWholeNumber) {
            return Math.floor(value);
          }

          return value;
        }
      } else {
        return '';
      }
    },
    removeCurrencyFormat(amount) {
      amount = String(amount).replace('$', '');
      return Number(String(amount).replace(/[^0-9.-]+/g, ""));
    },
    numberFormat(amount) {
      return parseFloat(amount).toFixed(2);
    },
    currencyFormat(amount, decPoint = 2) {

      var amt = String(amount).replaceAll(',', '');

      const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: decPoint,
        maximumFractionDigits: decPoint
      });

      if (parseFloat(amt) < 0) {
        var formattedAmt = "-$";
        var updatedAmount = formatter.format(parseFloat(amt)).replace("-", "");
        formattedAmt = formattedAmt + updatedAmount;
        return formattedAmt;
      } else {
        var formattedAmt = "$";
        return formattedAmt + formatter.format(parseFloat(amt));
      }
    },
    isNumberOnly: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf(
        '.') != -1) && (charCode !== 45 || evt.target.value.indexOf('-') != -1)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    removeOptionArr: function (filterArr) {
      var self = this;

      if (filterArr) {
        var listFilter = [];
        for (var j = 0; j < filterArr.length; j++) {

          //to skip if any filter added but column not selected
          if (filterArr[j].columnId == null) {
            continue;
          }

          var temp = filterArr[j];
          //const tempMyObj = Object.assign({}, myObj);

          if (temp != undefined) {

            if (temp.columnId != null && temp.columnId['fpFieldType'] != undefined) {

              if (temp.columnId['fpFieldType'] == "option") {
                // if(temp.columnId.field != null && temp.columnId.field == 'location'){
                // if(temp.filterOption.length == undefined || temp.filterOption.length == 0){
                temp.filterOption = [];
                // }
                listFilter.push(temp);
                // }
              } else {
                listFilter.push(temp);
              }

            }
          }

        }
        if (listFilter.length != undefined && listFilter.length > 0) {
          return listFilter;
        }
      }

    },
    redirectPageRoleWise(defaultUrl, roleUrl, moduleName) {
      var self = this;
      var roleName = "";
      var redPageUrl = 'false';
      var userObj = JSON.parse(localStorage.getItem("user_obj"));
      // if (userObj != null) {
      //     if (userObj.roles.length > 0) {
      //         roleName = userObj.roles[0].name.toLowerCase();
      //     }
      // }
      if (userObj != null) {
        for (var i = 0; i < userObj.roles.length; i++) {
          roleName = userObj.roles[i].name;
          if (roleName == "service manager" || roleName == "service administrator" || roleName == "service supervisor"
            || roleName == "part administrator") {
            redPageUrl = 'true';
          }


        }
      }
      if (roleName != "" && roleName != null) {
        if (moduleName == "wo-invoice") {
          if (redPageUrl == 'true') {
            self.redirectPageUrl(roleUrl);
          } else {
            self.redirectPageUrl(defaultUrl);
          }
        } else {
          self.redirectPageUrl(defaultUrl);
        }
      }
    },
    createOrUpdateLocalStorageArray(module_id, user_id, module, type, flag) {
      var self = this;
      var ntfs = localStorage.getItem('view_edit_notifications');
      if (ntfs == null) {
        var arr = [];
        arr.push({'module_id': module_id, 'user_id': user_id, 'type': type, 'flag': flag, 'timestamp': Date.now()});
        localStorage.setItem('view_edit_notifications', JSON.stringify(arr));
        self.callAjaxViewEditNotification(module_id, user_id, module, type, flag);

      } else {
        ntfs = JSON.parse(ntfs);
        var call_ajax = true;
        for (let i = 0; i < ntfs.length; i++) {
          const diffInMs = Math.abs(ntfs[i]['timestamp'] - Date.now());
          // convert the difference to hours
          const hours = Math.floor(diffInMs / (1000 * 60 * 60));
          if (ntfs[i]['module_id'] == module_id && ntfs[i]['type'] == type && ntfs[i]['flag'] == flag && ntfs[i]['user_id'] == user_id) {
            if (hours <= process.env.VIEW_EDIT_NOTIFY_HOURS) {
              var call_ajax = false;
            } else {
              ntfs.splice(i, 1);
            }
          }
        }
        if (call_ajax) {
          ntfs.push({'module_id': module_id, 'user_id': user_id, 'type': type, 'flag': flag, 'timestamp': Date.now()});
          localStorage.setItem('view_edit_notifications', JSON.stringify(ntfs));
          self.callAjaxViewEditNotification(module_id, user_id, module, type, flag);
        }
      }
    },
    callAjaxViewEditNotification(module_id, user_id, module, type, flag) {
      $.ajax({
        url: process.env.ROOT_API + "/view_edit_notification",
        type: "post",
        crossDomain: true,
        headers: this.ajxHeaders,
        data: {
          module_id: module_id,
          module: module,
          type: type,
          flag: flag
        },
        dataType: "json",
        success: function (data) {
          if (data.status == 'success') {

          }
        },
        error: function (jqXHR, exception) {

        }
      });
    },
    left_view_edit_channel(from_path) {
      var segments = from_path.split("/");
      var type = segments[1];
      var m_id = segments[3];
      var channel_prefix = type + '-viewedit';
      var env = process.env.NODE_ENV;
      window.Echo.leave(env + '-' + channel_prefix + '-' + m_id);
    },
    join_view_edit_channel(type, flag, m_id) {
      var self = this;
      //Listen ViewEditEvent Event
      var channel_prefix = type + '-viewedit';
      var userObj = JSON.parse(localStorage.getItem("user_obj"));
      var env = process.env.NODE_ENV;
      //checking notification
      window.Echo.private(env + '-' + channel_prefix + '-' + m_id).listen('ViewEditEvent', (e) => {
        const content = {
          component: CrediOverrideNotification,
          props: {
            status: e.payload.status,
            sender: e.payload.sent_by_name,
            customer_id: e.payload.customer_id,
            module: e.payload.module_name,
            type: e.payload.type,
            flag: e.payload.flag
          },
        }
        if (userObj.id != e.payload.user_id && e.payload.flag != flag) {
          var ntfs = localStorage.getItem('view_edit_notifications');
          if (ntfs == null) {
            this.$toast(content, {timeout: false, closeButton: false});
            self.createOrUpdateLocalStorageArray(m_id, e.payload.user_id, 'view_edit_details', type, flag);
          } else {
            ntfs = JSON.parse(ntfs);
            var call_toast = true;
            for (let i = 0; i < ntfs.length; i++) {
              const diffInMs = Math.abs(ntfs[i]['timestamp'] - Date.now());
              // convert the difference to hours
              const hours = Math.floor(diffInMs / (1000 * 60 * 60));
              if (ntfs[i]['module_id'] == m_id && ntfs[i]['type'] == type && ntfs[i]['flag'] == flag && ntfs[i]['user_id'] == e.payload.user_id) {
                if (hours <= process.env.VIEW_EDIT_NOTIFY_HOURS) {
                  call_toast = false;
                }
              }
            }
            if (call_toast) {
              this.$toast(content, {timeout: false, closeButton: false});
            }
            self.createOrUpdateLocalStorageArray(m_id, e.payload.user_id, 'view_edit_details', type, flag);
          }
        }
      });

    },
    validateTime(evt) {

      var self = this;

      if (evt.target.value == '') {
        return true;
      }
      var timeVal = evt.target.value;
      console.log("timeVal " + timeVal);
      const isValid = self.validateTimeFormat(timeVal);
      if (!isValid && timeVal.length == 5) {
        console.log("invalid error")
        $(evt.target).closest(".form-group").find(".field-error").text("Please enter time in 12Hr format.");
        //evt.preventDefault();
      } else {
        $(evt.target).closest(".form-group").find(".field-error").text("");
        return true;
      }
    },
    // Validate time format (custom validation function)
    validateTimeFormat: function (timeVal) {
      //alert(timeVal)
      const regex = /^(0?[1-9]|1[0-2]):[0-5][0-9]$/;
      return regex.test(timeVal);
    },
    gotoNextStepMixins: function (flag) {
      var self = this;
      var error = false;
      var path = window.location.pathname;
      var segments = path.split("/");

      if (error != true) {
        $('.setup-y ').hide();
        var curStep = $(this).closest(".setup-content"),
          curStepBtn = curStep.attr("id"),
          nextStepWizard = $('div.setup-panel div a[href="#' + flag + '"]').parent().next().children("a");

        nextStepWizard.removeAttr('disabled').trigger('click');
      }
      $('div.setup-panel div a.btn-primary').trigger('click');

    },
    gotoBackStepMixins: function (flag) {
      var self = this;
      $('div.setup-panel div a[href="#' + flag + '"]').trigger('click');
    },

    // attachments for the ev warranty claims

    uploadAttachment(attachmentType, index) {
      var self = this;

      const attachmentTypesConfig = this.getAttachmentTypeConfigs();
      const config = attachmentTypesConfig[attachmentType];

      if (!config) {
        console.error("Invalid attachment type!");
        return;
      }

      const {rows, attachmentProperty, errorProperty, attachmentPath} = config;


      let attachmentValidity = this.fileAttachmentValidation(index, config);
      if (attachmentValidity) {
        let formData = this.getFormData(attachmentType, index, config);
        if (formData == false) {
          console.log("Error, invalid atttachment type");
          return;
        }
        self.$parent.loading = true;
        $.ajax({
          url: process.env.ROOT_API + "/upload-warranty-claim-attachment",
          type: "POST",
          data: formData,
          headers: {
            "Accept": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Authorization": "Bearer " + localStorage.getItem("tkn"),
            "Access-Control-Allow-Headers":
              "Origin, Content-Type, Authorization,X-Requested-With",
            "Cache-Control": "no-cache"
          },
          crossDomain: true,
          processData: false,
          contentType: false,
          dataType: "json",
          success: function (data) {
            self.$parent.loading = false;
            if (data.status == "success") {
              rows[index][attachmentPath] = data.content;
            } else {
              rows[index][errorProperty] = data.message;
            }
          },
          error: function (jqXHR, exception) {
            self.$parent.loading = false;
            self.generateStatusCodeMessage(jqXHR, true, 'file-attachment-upload-error');
          }
        });
      }
    },

    getAttachmentTypeConfigs() {
      return {
        partAttachment: {
          rows: this.rows,
          attachmentProperty: 'partAttachment',
          errorProperty: 'partAttachmentError',
          attachmentPath: 'partAttachmentPath',
        },
        nonOemPartAttachment: {
          rows: this.oem_rows,
          attachmentProperty: 'attachment',
          errorProperty: 'attachmentError',
          attachmentPath: 'attachmentPath',
        },
        laborAttachment: {
          rows: this.rows,
          attachmentProperty: 'attachment',
          errorProperty: 'attachmentError',
          attachmentPath: 'attachmentPath',
        },
        // Add more attachment types here as needed
      };
    },

    fileAttachmentValidation(index, config) {
      const extension = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'xls', 'xlsx'];
      const {rows, attachmentProperty, errorProperty, attachmentPath} = config;

      rows[index][errorProperty] = "";

      const attachment = rows[index][attachmentProperty];

      if (attachment == "" || attachment == null) {
        rows[index][errorProperty] = "Please Select File!";
        console.log("return because no file!");
        return false;
      }

      const fileSize = attachment.size;
      if (fileSize != undefined) {
        if (fileSize > 10000000) {
          rows[index][errorProperty] = "File size should not be greater than 10 MB.";
          console.log("return because no file too large!");
          return false;
        }
      }

      if ($.inArray(attachment.name.split('.').pop().toLowerCase(), extension) == -1) {
        rows[index][errorProperty] = "Only formats are allowed: " + extension.join(', ');
        console.log("return because extension problem!");
        return false;
      }
      return true;
    },

    getFormData(attachmentType, index, config) {

      const {rows, attachmentProperty, errorProperty, attachmentPath} = config;
      const attachment = rows[index][attachmentProperty];

      let formData = new FormData();
      formData.append('attachment', attachment);
      formData.append('attachmentType', attachmentType);
      return formData;
    },

    deleteAttachment(index, attachmentType) {
      var self = this;
      self.$parent.loading = true;

      const attachmentTypesConfig = this.getAttachmentTypeConfigs();
      const config = attachmentTypesConfig[attachmentType];

      if (!config) {
        console.error("Invalid attachment type!");
        return;
      }

      const {rows, attachmentProperty, errorProperty, attachmentPath} = config;

      let warrantyLineId = this.getIdForDelete(rows, index, attachmentType);
      let fileName = rows[index][attachmentPath];

      const data = {
        warrantyLineId: warrantyLineId,
        fileName: fileName,
        attachmentType: attachmentType,
      };
      $.ajax({
        url: process.env.ROOT_API + "/delete/warranty-claim-attachment",
        type: "POST",
        data: data,
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          "Access-Control-Allow-Headers":
            "Origin, Content-Type, Authorization,X-Requested-With",
          "Cache-Control": "no-cache"
        },
        dataType: "json",
        success: function (data) {
          self.$parent.loading = false;
          rows[index][attachmentProperty] = null;
          rows[index][attachmentPath] = null

        },
        error: function (jqXHR, exception) {
          self.$parent.loading = false;
          rows[index][errorProperty] = data.message;
        }
      });
    },

    getIdForDelete(rows, index, attachmentType) {
      if (attachmentType == "nonOemPartAttachment") {
        return null;
      } else {
        return rows[index]['item_id'];
      }
    },
    loadUserDealerMapper(id) {
      var self = this;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/dealer-dropdown/" + id,
        type: "GET",
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          self.dealerArr = data.content;
          var path = window.location.pathname;
          var segments = path.split("/");
          if (!segments[3]) {
            self.dealer_id = self.dealerArr[0];
            self.dealer_address = self.dealer_id ? self.dealer_id.address_line_1 : '';
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'get-customer-number');
        }
      });
    },

    getDocumentPath(id, path, flag) {
      if (path != null && path != "") {
        var self = this;
        self.loading = true;
        $.ajax({
          url: process.env.ROOT_API + "/generate-document-link",
          type: "POST",
          data: {
            id: id,
            path: path,
            flag: flag,
          },
          headers: this.ajxHeaders,
          dataType: 'json',
          success: function (data) {
            self.loading = false;
            if (data.code == 200) {
              let doc = document.createElement('a');
              doc.href = data.content;
              doc.download = data.content;
              doc.target = '_blank';
              document.body.appendChild(doc);
              doc.click();
              document.body.removeChild(doc);
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            self.generateStatusCodeMessage(jqXHR, false, 'get-document-path');
          }
        });
      }
    },

    getLogInfo(logId, flag) {
      var self = this;
      self.loading = true;
      self.logs = [];

      $.ajax({
        url: process.env.ROOT_API + "/activity-log",
        type: "GET",
        data: {
          id: logId,
          flag: flag,
        },
        headers: this.ajxHeaders,
        dataType: 'json',
        success: function (data) {
          self.loading = false;
          if (data.code == 200) {
            $("#logViewModal").modal('show');
            self.logs = data.result;
          }
          if (data.code == 400) {
            $("#errorMsg").html(data.message);
            $(".alert-warning").toggleClass("show");
            setTimeout(function () {
              $(".alert-warning").removeClass("show");
              $(".alert-warning").addClass("hide");
            }, 5000);
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'get-logs');
        }
      });
    },
    capitalizeFirstLetters(str) {
      return str.replace(/\b\w/g, char => char.toUpperCase());
    },
    formatNegativeValueWithParentheses(value, decPoint = 2, text = '') {
      if (text == 'total' && !value) {
        return '0';
      }
      if (value) {
        // Remove commas if present
        if (typeof value === 'string' && value.includes(',')) {
          value = parseFloat(value.replace(/,/g, ''));
        }

        // Check if the value is a valid number and is negative
        const isNegative = !isNaN(value) && value < 0;

        // Check if the value is a whole number
        const isWholeNumber = Number(value) === Math.floor(value);

        // Set decimal points dynamically based on whether the value is whole
        const minFractionDigits = isWholeNumber ? 0 : decPoint;
        const maxFractionDigits = isWholeNumber ? 0 : decPoint;

        // Format the value
        const formatter = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: minFractionDigits,
          maximumFractionDigits: maxFractionDigits
        });

        let formattedAmount = formatter.format(Math.abs(value));

        // Wrap in parentheses if the value is negative
        if (isNegative) {
          formattedAmount = `(${formattedAmount})`;
        }

        return formattedAmount;
      } else {
        return '';
      }
    },
    formatAmountToFloatNew(value) {
      // Preserve the negative sign and remove other non-numeric characters except the decimal point
      if (typeof value === 'string') {
        return parseFloat(value.replace(/[^0-9.-]/g, ''));
      } else {
        return value;
      }
    },
    filterNumericValue(event) {
      const allowedKeys = ['Backspace', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'Delete'];
      const isNumberKey = event.key >= '0' && event.key <= '9';
      const isDecimalPoint = event.key === '.';
      const isDollarSign = event.key === '$';

      // Prevent any key not allowed
      if (
        !allowedKeys.includes(event.key) && // Allow control keys
        !isNumberKey && // Allow number keys
        !isDecimalPoint && // Allow one decimal point
        !isDollarSign // Allow one dollar sign
      ) {
        event.preventDefault();
      }

      // Prevent more than one decimal point
      if (isDecimalPoint && event.target.value.includes('.')) {
        event.preventDefault();
      }

      // Prevent more than one dollar sign and ensure it's at the start
      if (isDollarSign && (event.target.value.includes('$') || event.target.selectionStart !== 0)) {
        event.preventDefault();
      }
    },
    filterWholeNumericValue(event) {
      const allowedKeys = ['Backspace', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'Delete'];
      const isNumberKey = event.key >= '0' && event.key <= '9';

      // Prevent any key that is not allowed
      if (!allowedKeys.includes(event.key) && !isNumberKey) {
        event.preventDefault();
      }
    },
    formatCurrency(value) {
      if (value) {
        if (value == '-') {
          return `$0`;
        } else {
          // Check if the value ends with ".00"
          if (parseFloat(value) === Math.floor(value)) {
            value = Math.floor(value);  // Remove decimals for whole numbers like 20.00
          }
        }

        return `$${value}`;
      } else {
        return '$0';
      }
    },
    scrollToTop() {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }, 300);
    },
    isDecimalValue(event) {
      const allowedKeys = ['Backspace', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'Delete'];
      const isNumberKey = event.key >= '0' && event.key <= '9';
      const isDecimalPoint = event.key === '.';

      // Prevent any key not allowed
      if (
        !allowedKeys.includes(event.key) && // Allow control keys
        !isNumberKey && // Allow number keys
        !isDecimalPoint // Allow one decimal point
      ) {
        event.preventDefault();
      }

      // Prevent more than one decimal point
      if (isDecimalPoint && event.target.value.includes('.')) {
        event.preventDefault();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/commonMixins.js